import React from "react";

export default function RegistrationOrigin({ source }) {
  const value = String(source || "").trim().toLowerCase();
  const label = value === "self_service" ? "Self-registered" : value === "owner_app_manual" ? "Added on device"
    : ["director", "owner", "owner_managed", "walk_up", "walkup"].includes(value) ? "Added by director" : null;
  return label ? <span className="registration-origin">{label}</span> : null;
}
